import { styled, theme } from '@/src/stitches.config'
import { useState } from 'react'
import { FormErrorDisplay } from '../../build-a-card/FormErrorDisplay'
import { IDeliveryStreetAddress } from '../../cart/ICart'
import { FieldWrapper } from '../../smarty/StyledComponents'
import ManualAddressForm from '../forms/ManualAddressForm'
import SmartyAddressForm from '../forms/SmartyAddressForm'
import handleEnterPressEvent from '@/src/common/utilities/handleEnterPressEvent'

const SearchText = styled('p', {
    textDecoration: 'underline',
    color: '$secondary',
    cursor: 'pointer',
    width: 'fit-content',
    mt: 5,
    mb: 20,
})

export default function AddressForm({
    value,
    onChange,
    formErrors = [],
}: {
    value?: IDeliveryStreetAddress
    onChange: (address: IDeliveryStreetAddress) => any
    formErrors?: any[]
}) {
    const [manualEntry, setManualEntry] = useState(false)

    return (
        <div>
            {manualEntry && (
                <SearchText
                    onClick={() => setManualEntry(false)}
                    onKeyDown={(e) =>
                        handleEnterPressEvent(e, () => setManualEntry(false))
                    }
                    tabIndex={0}
                >
                    Search for an address
                </SearchText>
            )}

            {manualEntry ? (
                <ManualAddressForm
                    address={
                        value ?? { address1: '', city: '', state: '', zip: '' }
                    }
                    setAddress={(address: IDeliveryStreetAddress) => {
                        onChange(address)
                    }}
                    formErrors={formErrors}
                    setFormErrors={() => {}}
                />
            ) : (
                <FieldWrapper>
                    <SmartyAddressForm
                        value={value}
                        error={formErrors.some((e) => e.path === 'address1')}
                        onChange={(address: IDeliveryStreetAddress) => {
                            onChange(address)
                        }}
                        toggleManualEntry={(manual) => setManualEntry(manual)}
                        listMaxHeight={150}
                    />
                    <FormErrorDisplay
                        formErrors={formErrors}
                        path={'address1'}
                    />
                </FieldWrapper>
            )}

            {!manualEntry && (
                <>
                    <p style={{ marginBottom: 5 }}>
                        Didn&#39;t find the right address?
                    </p>

                    <p style={{ marginTop: 0 }}>
                        {value?.address1 && (
                            <>
                                <span
                                    data-testid={'search-again'}
                                    onClick={() => {
                                        onChange({
                                            address1: '',
                                            address2: '',
                                            city: '',
                                            state: '',
                                            zip: '',
                                        })
                                    }}
                                    onKeyDown={(e) => {
                                        handleEnterPressEvent(e, () =>
                                            onChange({
                                                address1: '',
                                                address2: '',
                                                city: '',
                                                state: '',
                                                zip: '',
                                            })
                                        )
                                    }}
                                    style={{
                                        textDecoration: 'underline',
                                        color: `${theme.colors.secondary}`,
                                        cursor: 'pointer',
                                    }}
                                    tabIndex={0}
                                >
                                    Search again
                                </span>

                                <span> or </span>
                            </>
                        )}

                        <span
                            data-testid={'enter-manually'}
                            onClick={() => setManualEntry(true)}
                            onKeyDown={(e) =>
                                handleEnterPressEvent(e, () =>
                                    setManualEntry(true)
                                )
                            }
                            style={{
                                textDecoration: 'underline',
                                color: `${theme.colors.secondary}`,
                                cursor: 'pointer',
                            }}
                            tabIndex={0}
                        >
                            Enter it manually
                        </span>
                    </p>
                </>
            )}
        </div>
    )
}
